// frozen_string_literal: true

export class MetricUpdater {
  applyTestTelemetryData(vehicles) {
    return vehicles.map(vehicle => {
      const testVehicle = { ...vehicle }
      
      // Simular velocidade mudando
      if (vehicle.has_speed || vehicle.plate) {
        testVehicle.has_speed = true
        testVehicle.speed = Math.floor(Math.random() * 120) + 10 // 10-130 km/h
      }
      
      // Simular RPM mudando
      if (vehicle.has_rpm || vehicle.plate) {
        testVehicle.has_rpm = true
        testVehicle.rpm = Math.floor(Math.random() * 3000) + 800 // 800-3800 RPM
      }
      
      // Simular voltagem mudando
      if (vehicle.has_voltage || vehicle.plate) {
        testVehicle.has_voltage = true
        testVehicle.voltage = (Math.random() * 2 + 11).toFixed(1) // 11.0-13.0V
      }
      
      // Simular bateria backup mudando
      if (vehicle.has_backup_battery || vehicle.plate) {
        testVehicle.has_backup_battery = true
        testVehicle.backup_battery = Math.floor(Math.random() * 100) + 1 // 1-100%
      }
      
      // Simular temperatura mudando
      if (vehicle.has_temperature || vehicle.plate) {
        testVehicle.has_temperature = true
        testVehicle.temperature = Math.floor(Math.random() * 40) + 20 // 20-60°C
      }
      
      return testVehicle
    })
  }
}